import request from '@/config/axios'

export interface ShortVideoRecommendVO {
  id?: number
  videoId: number
  videoTitle?: string
  coverUrl?: string
  position: string
  sort?: number
  status?: number
  startTime?: string
  endTime?: string
  remark?: string
  createTime?: string
}

export const pageRecommend = (params: any) =>
  request.get({ url: '/short-video/recommend/page', params })
export const getRecommend = (id: number) =>
  request.get({ url: '/short-video/recommend/get', params: { id } })
export const createRecommend = (data: ShortVideoRecommendVO) =>
  request.post({ url: '/short-video/recommend/create', data })
export const updateRecommend = (data: ShortVideoRecommendVO) =>
  request.put({ url: '/short-video/recommend/update', data })
export const deleteRecommend = (id: number) =>
  request.delete({ url: '/short-video/recommend/delete', params: { id } })
